/*
    - Author: @aday 
    - Version: 1.0.0
    - Date: 2025-06-25
    - Description: This script is used to add flavors to an existing item.
    - Usage: await updateItemFlavors();
*/

const getUrlVariable = variable => {
    const params = new URLSearchParams(window.location.search);
    return params.get(variable);
};

const itemKey = getUrlVariable('key');

const updateItemFlavors = async props => {
    try {
        
        if(!itemKey) {
            return;
        }

        const data = {
            id: itemKey,
            properties: props
        };

        const newCart = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .catch(error => {
            console.error('Error posting data to Shopify:', error);
        });

        if(newCart && newCart.items) {
            window.location.href = '/cart';  
        }
    }
    catch(error) {
        console.error('Error updating item flavors:', error);
    }
};

// Hide extra options below "Secure Checkout" button

const hideUpsells = () => {
    const upsells = document.querySelectorAll('.Box__Footer__Row p');
    upsells.forEach(upsell => {
        // keep the container as the spacer
        upsell.innerText = '';
    });
};

// CTA cannot add a new product to the cart but update flavors instead

const overrideCta = () => {
    if(itemKey) {

        const flavorProps = {};
      
        hideUpsells();

        document.querySelector('form').addEventListener('submit', event => {
            event.preventDefault(); 
        });
        
        document.querySelector('input[type="submit"]')?.addEventListener('click', event => {

            event.preventDefault();
            
            [...document.querySelectorAll('input[type="hidden"]')]
            .filter(input => input.name && input.name.toLowerCase().includes('pk'))
            .forEach(flavor => {
                flavorProps[flavor.name.replace(/properties\[(.*?)\]/, "$1")] = flavor.value;
            });
            
            updateItemFlavors(flavorProps);
            
        });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    overrideCta();
});